import React, { useState } from 'react';
import Alert from './Alert';
import { useTranslation } from 'react-i18next';
//import i18n from '../i18n';
import {  useLocation, useNavigate } from 'react-router-dom';


function CreateContact({ socket, prompt }) {
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
const [successMessage, setSuccessMessage] = useState('');
const [errorMessage, setErrorMessage] = useState('');
const { t } = useTranslation();
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';
const location = useLocation();
const navigate = useNavigate();

const fromDiscussionId = location.state?.fromDiscussion;

  const handleCreateContact = () => {

    if (!navigator.contacts) {
      console.error('La fonctionnalité de contacts n\'est pas disponible.');
      return;
    }

    let contact = navigator.contacts.create();
    contact.displayName = name;
    contact.name = { givenName: name };

    if (phone) {
      contact.phoneNumbers = [{ type: 'mobile', value: phone, pref: true }];
    }

    if (email) {
      contact.emails = [{ type: 'email', value: email, pref: true }];
    }

    contact.save(
      () => {
        setName('');
        setPhone('');
        setEmail('');
  setSuccessMessage(t('createcontact.succes'));
    },
      (error) => {
        console.error('Erreur lors de la création du contact : ', error);
setErrorMessage(t('createcontact.error'));
      }
    );
  };

//const { alert, confirm, modal} = prompt;
const { alert } = prompt;

const handleBackToDiscussions = () => {
    if (fromDiscussionId) {
      // Revenir à la discussion fullscreen
      navigate('/', {
        state: { reopenDiscussionId: fromDiscussionId },
      });
    } else {
      navigate(-1); // comportement par défaut
    }
  };


  return (

<div className="auth-container-contact">
    <div className="auth-form">
<div style= {{ fontSize: '36px', marginBottom: '30px', marginTop: '30px' }}>
 <i className="ti ti-address-book" style={{ fontSize: '36px', marginBottom: '16px', marginTop: '30px', display: 'block', textAlign: 'center', color: 'var(--toolbar-bg)' }} aria-hidden="true" />
</div>

      <h2>{t('createcontact.newtitle')}</h2>


<Alert type="error" message={errorMessage} />
    <Alert type="success" message={successMessage} />

      <form className="update-form"
        onSubmit={(e) => {
          e.preventDefault();
          handleCreateContact();
        }}
      >
        <div >
          
          <input
            type="text"
            value={name}
		placeholder={t('createcontact.name')}
            onChange={(e) => setName(e.target.value)}
		className="form-input"
            required
          />
<label className="form-label">
  	<span className="required">*</span>
	</label>
        </div>
        
  <div style= {{ position: 'relative' }}>
    <input
      type="email"
      value={email}
      placeholder={t('createcontact.email')}
      onChange={(e) => setEmail(e.target.value)}
      className="form-input"
      required
    />
<label className="form-label">
    <span className="required">*</span>
  </label>
    <span
    className="info-bubble"
style={{ position:'absolute', right:'0px', top:'10px' }}
    onClick={() => prompt.alert(t('createcontact.info'))}
  >
 <i className="ti ti-info-circle" style={{ fontSize: '16px', color: '#3498db' }} aria-hidden="true" />

  </span>
  

</div>

	<div>
 
          <input
            type="tel"
            value={phone}
		placeholder={t('createcontact.phonenumber')}
            onChange={(e) => setPhone(e.target.value)}
		className="form-input"
            
          />
<label className="form-label">
  	<span className="not_required">*</span>
	</label>
        </div>
{/* Légende champs obligatoires */}
        <p style={{ fontSize: '11px', opacity: 0.5, margin: '0 0 16px', textAlign: 'left' }}>
          <span className="required">*</span> {t('createcontact.required')}
        </p>
        <button type="submit" className="btn-primary">
<i className="ti ti-user-plus" style={{ fontSize: '16px', marginRight: '8px' }} aria-hidden="true" />
{t('createcontact.createcontact')}</button>
      </form>
    </div>
</div>
  );
}

export default CreateContact;
